import React, { useState, useEffect } from 'react';
import {
    Paper,
    Typography,
    TextField,
    Button,
    Grid,
    Box
} from '@mui/material';
import { notification } from "antd";
import { getResponseErrorMessage } from '@/utils/api-service';
import api from "@/api";

// Компонент для настроек по умолчанию
const DefaultSettings = ({ settings, onSave }) => {
    const [localSettings, setLocalSettings] = useState(settings);

    useEffect(() => {
        setLocalSettings(settings);
    }, [settings]);

    const handleChange = (field) => (event) => {
        setLocalSettings({
            ...localSettings,
            [field]: event.target.value
        });
    };

    const handleSave = async () => {
        try {
            //console.log(localSettings);

            await api.adtag.saveDefaultSettings(localSettings);
            onSave(localSettings);
            notification.success({
                message: "Настройки по умолчанию сохранены!",
            })
        } catch (error) {
            console.error('Ошибка сохранения:', error);
            const messageFormatter = getResponseErrorMessage(error, 'Ошибка при сохранении настроек')
            notification.error({
                message: messageFormatter
            });
        }
    };

    return (
        <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
                Настройки по умолчанию
            </Typography>
            <Grid container spacing={2}>
                <Grid item size={{ lg: 4 }}>
                    <TextField
                        fullWidth
                        label="Preroll"
                        value={localSettings.preroll || ''}
                        onChange={handleChange('preroll')}
                        variant="outlined"
                    />
                </Grid>
                <Grid item size={{ lg: 4 }}>
                    <TextField
                        fullWidth
                        label="Midroll"
                        value={localSettings.midroll || ''}
                        onChange={handleChange('midroll')}
                        variant="outlined"
                    />
                </Grid>
                <Grid item size={{ lg: 4 }}>
                    <TextField
                        fullWidth
                        label="Postroll"
                        value={localSettings.postroll || ''}
                        onChange={handleChange('postroll')}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={!localSettings.preroll || !localSettings.midroll || !localSettings.postroll}
                >
                    Сохранить настройки
                </Button>
            </Box>
        </Paper>
    );
};



export default DefaultSettings;